import { getData } from "@/lib/utils";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import api from "@/store/api";
import { useState } from "react";

export const useSales = () => {
  const Token = getData("tokens")?.accessToken;
  const { locale } = useLocale();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { t } = useTranslate(locale);
  const updateStatus = async (id: string, values: { status: string }) => {
    try {
      setIsLoading(true);
      setError(null);
      const Token = getData("tokens")?.accessToken;
      if (!Token) {
        throw new Error("Authentication token is missing");
      }

      const response = await api.patch(`/web/sales/${id}/status`, values, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      if (response.data.isSuccess) {
        return {
          isSuccess: true,
          data: response.data.data,
        };
      } else {
        throw new Error(response.data.message || "Failed to create order");
      }
    } catch (err: any) {
      console.error(err);

      return {
        isSuccess: false,
        message: err.response?.data?.message || t("Alert.OrderTryAgain"),
      };
    } finally {
      setIsLoading(false);
    }
  };
  const getSales = async (
    pageSize: number = 10,
    pageNumber: number = 1,
    withPagination: boolean = false
  ) => {
    const response = await api.get(
      `/web/sales/seller?pageSize=${pageSize}&pageNumber=${pageNumber}&withPaging=${withPagination}`,
      {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }
    );
    return response.data;
  };

  return { getSales, updateStatus, isLoading, error };
};
